import React from "react";

export interface CardBodyProps {
  /**
   * Content inside the card body, can be text or JSX elements.
   */
  children: React.ReactNode;
}

/**
 * The body section of the card for primary content, descriptions, or supporting information.
 */
export const CardBody: React.FC<CardBodyProps> = ({ children }) => {
  return <div className="p-4">{children}</div>;
};

export default CardBody;
